const data = [
    {
      question: "What is the third Fruit of the Spirit?",
      incorrectAnswers: [
        "Kindness",
        "Joy",
        "Love",
      ],
      correctAnswer: "Peace",
    },
  
    {
      question: "[And, behold, I come quickly; and my reward is with me, to give every man according as his work shall be.] can be found where?",
      incorrectAnswers: [
        "Revelation 1:10",
        "Revelation 2:22",
        "Revelation 22:10",
      ],
      correctAnswer: "Revelation 22:12",
    },
    {
      question: "What is the First Fruit of the Spirit according to the Bible?",
      incorrectAnswers: ["Peace", "Kindness", "Gentleness"],
      correctAnswer: "Love",
    },
    {
      question: "What is the Fourth Fruit of the Spirit according to the Bible?",
      incorrectAnswers: ["Gentleness", "Goodness", "Patience"],
      correctAnswer: "Long suffering",
    },
    {
      question: "What is the Last Fruit of the Spirit according to the Bible?",
      incorrectAnswers: [
        "Peace",
        "Hope",
        "Faith",
      ],
      correctAnswer: "Temperance",
    },
    {
      question: "Where can we find the gifts of the Holy Spirit in the Bible?",
      incorrectAnswers: [
        "Romans 12",
        "Exodus 4",
        "Galatians 5",
      ],
      correctAnswer: "1 Corinthians 12",
    },
    {
      question: "Paul had a Revelation of Christ on his way to _________ ?",
      incorrectAnswers: ["Judah", "Jerusalem", "Egypt"],
      correctAnswer: "Damascus",
    },
    {
      question: "ADONAI means?",
      incorrectAnswers: [
        "Eternal, Strong, King",
        "Good, Holy, Just",
        "Great, Mighty, God",
      ],
      correctAnswer: "Lord, Master, Owner, Ruler",
    },
    {
        question: "JEHOVAH: the personal NAME of God in His relationship as __________.?",
        incorrectAnswers: [
          "SAVIOUR",
          "RULER",
          "KING",
        ],
        correctAnswer: "REDEEMER",
    },
    {
        question: "Which of the 7 deacons had a revelation of Christ in Heaven at the point of death?",
        incorrectAnswers: [
          "Nicanor",
          "Phillip",
          "Matthias",
        ],
        correctAnswer: "Stephen",
    },
    {
      question: "Which of the Apostles was killed upside down for Christ's sake?",
      incorrectAnswers: [
        "Timothy",
        "Paul",
        "John",
      ],
      correctAnswer: "Peter",
  },
  {
    question: "What instrument will sound at the second coming of Jesus Christ?",
    incorrectAnswers: [
      "Loud Speaker",
      "Keyboard",
      "Guitar",
    ],
    correctAnswer: "The Trumpet",
  },
  {
    question: "The way to Hell is very _________ ?",
    incorrectAnswers: [
      "Broad",
      "Long",
      "Narrow",
    ],
    correctAnswer: "Wide",
  },
  {
    question: "What Armour of God is worn on the head?",
    incorrectAnswers: [
      "Joy",
      "Peace",
      "Hope",
    ],
    correctAnswer: "Salvation",
  },
  {
    question: "What Armour of God is worn on the chest?",
    incorrectAnswers: [
      "Purity",
      "Holiness",
      "Peace",
    ],
    correctAnswer: "Righteousness",
  },
  {
    question: "What Armour of God is worn on the feet?",
    incorrectAnswers: [
      "Prayer",
      "The Word",
      "Anointing",
    ],
    correctAnswer: "The Gospel of Peace",
  },
  {
    question: "What Armour of God is carried in our hands?",
    incorrectAnswers: [
      "Holiness",
      "Righteousness",
      "Prayers",
    ],
    correctAnswer: "The Word",
  },
  {
    question: "What Armour of God is our defense?",
    incorrectAnswers: [
      "Truth",
      "Righteousness",
      "Joy",
    ],
    correctAnswer: "Faith",
  },
  {
    question: "What Armour of God is worn around our waists",
    incorrectAnswers: [
      "Faith",
      "Joy",
      "Righteousness",
    ],
    correctAnswer: "Truth",
  },
  {
    question: "Where in the Bible can we find the Whole Armour of God?",
    incorrectAnswers: [
      "Ephesians 4:10-18",
      "Ephesians 6:10-12",
      "Ephesians 3:10-18",
    ],
    correctAnswer: "Ephesians 6:10-18",
  },
];
  
export default data;